export default __webpack_public_path__ + "static/media/trame.7756de5f.svg";